import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@cfp/core';

@Component({
  selector: 'cfp-demo-anonymous-login-page',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoAnonymousLoginPage implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  public ngOnInit(): void {
    const demoAccessToken = localStorage.getItem('demoAccessToken');
    if (!demoAccessToken) {
      this.router.navigateByUrl('/');
      return;
    }

    localStorage.removeItem('demoAccessToken');
    this.authService.setAnonymousDemoUserAccessToken(demoAccessToken);
    this.authService.goToApp();
  }
}
